module.exports = __webpack_public_path__ + "img/ico_coinstore_rateus5star@3x.69df48e4.png";